import React from 'react';
import cx from 'classnames';
import styles from './Heading.module.scss';
import { HeadingProps, HeadingTags, HeadingTagsType } from './Heading.types';
import { TextColor } from '../../shared/types/textColor.types';

const Heading = ({
  bold = false,
  heading = HeadingTags.One,
  children,
  className,
  color = TextColor.Primary,
  onClick,
  tabIndex,
  onFocus,
  styleAs,
  dataCy = 'heading',
}: HeadingProps) => {
  const Tag: HeadingTagsType = `${heading}` as HeadingTagsType;
  return (
    <Tag
      data-cy={dataCy}
      className={cx(
        styles.heading,
        styles[`heading-${heading}`],
        styles[color],
        className,
        {
          [styles.bold]: bold,
          [styles.normal]: !bold,
        },
        styles[`${styleAs}`]
      )}
      onClick={onClick}
      onFocus={onFocus}
      tabIndex={tabIndex}>
      {children}
    </Tag>
  );
};

export default Heading;
